import { createContext } from 'react';

/**
 * ColorModeContext — アプリ全体のライト/ダークモード切替
 *
 * 提供される値:
 *   - mode: 'light' | 'dark'
 *   - toggleColorMode(): モードを切り替える (= localStorage 永続化付き)
 *   - setMode(next): 明示的にモードを設定
 */
export const ColorModeContext = createContext({
  mode: 'light',
  toggleColorMode: () => {},
  setMode: () => {},
});

export const COLOR_MODE_STORAGE_KEY = 'penlytics:colorMode';
